// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hv","belowWelcomeBackBanner":"hw","message":"hx","close":"hy","closeMessage":"hz","closeIcon":"hA"};